export default __webpack_public_path__ + "3cd472b67eb867cd7447fc553b724ef9.svg";